import Vue from 'vue'
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = process.env.VUE_APP_API_BASE;
Object.defineProperty(Vue.prototype, '$axios', { value: axios }); // Makes axios globally available in Vue

import ElementUI from 'element-ui';
import './element-variables.scss';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);
Vue.use(ElementUI);

import Vuex from 'vuex';
import vuexStore from './store.js';
Vue.use(Vuex);
var store = new Vuex.Store(vuexStore);

import App from './App.vue'

Vue.config.productionTip = false

import keyValueList from './components/basic/Key-Value-List';
import keyValueItem from './components/basic/Key-Value-Item';

Vue.component('key-value-list', keyValueList);
Vue.component('key-value-item', keyValueItem);

new Vue({
	store,
  render: h => h(App)
}).$mount('#app')
